// extracted by mini-css-extract-plugin
export default {"starWrapper":"StarRating_starWrapper__VCppQ","star":"StarRating_star__TnzC+","activeStar":"StarRating_activeStar__tgY80"};